// src/admin/components/WorkflowSelectionList.js
import React from 'react';
import PropTypes from 'prop-types';
import WorkflowSelectionCard from './WorkflowSelectionCard';

/**
 * WorkflowSelectionList
 *
 * - workflows: full list of workflows
 * - recentIds: array of workflow IDs to promote at top (in order)
 * - onSelect: callback(workflow)
 */
export default function WorkflowSelectionList({ workflows, recentIds, onSelect }) {
  // Build two lists: recently used, then the rest (excluding recents)
  const recent = recentIds
    .map(id => workflows.find(w => w.id === id))
    .filter(Boolean);

  const rest = workflows.filter(w => !recentIds.includes(w.id));

  if (!workflows.length) {
    return <p className="text-center text-muted">No workflows found</p>;
  }

  return (
    <>
      {recent.length > 0 && (
        <>
          <div className="text-uppercase text-muted small mb-2">Recently Used</div>
          {recent.map(wf => (
            <WorkflowSelectionCard key={wf.id} workflow={wf} onClick={onSelect} />
          ))}
          <hr />
        </>
      )}

      <div className="text-uppercase text-muted small mb-2">All Workflows</div>
      {rest.map(wf => (
        <WorkflowSelectionCard key={wf.id} workflow={wf} onClick={onSelect} />
      ))}
    </>
  );
}

WorkflowSelectionList.propTypes = {
  workflows: PropTypes.arrayOf(PropTypes.object).isRequired,
  recentIds: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
};
